<div>
   <div class="row">
        <div class="col-md-12">
            <div class="card-box mb-3 w-100">
                <div class="text-danger">
                    {{errorMessage}}
                </div>
                <from-date-to-date-pickers  :title="''"
                                            :fromDate="report.startDate"
                                            :toDate="report.endDate"
                                            :elementId="'dashboardReportDateFilter'"
                                            :dateFormat="'DD/MM/YYYY'"
                                            :hideClearButton="true"
                                            :initialiseDate="initialiseDatePicker"
                                            :initialiseDatePickerEndDate="initialiseDatePickerEndDate"
                                            @fromDateSelected="onFromReportDateSelect"
                                            @toDateSelected="onToReportDateSelect"></from-date-to-date-pickers>
                <br>
                <button class="btn btn-primary" @click="checkReportDeliveryVarianceReport">
                    Download Delivery Variance Report
                </button>
            </div>
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="deliveryOrderHeadings" :data="recentDeliveryOrders" :hasActions="true"
                                :hasNoPaging="true"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onOrderActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label>Order Status</label>
                                        <bootstrap-select  :selectOptions="orderStatuses" :selectedOption="filter.orderStatusId" :elementId="'orderStatusFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onOrderStatusSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="float-right pr-3">
                                            <from-date-to-date-pickers  :title="'Date Created'"
                                                                        :fromDate="filter.fromDateCreated"
                                                                        :toDate="filter.toDateCreated"
                                                                        :elementId="'customerDateFilter'"
                                                                        :dateFormat="'DD/MM/YYYY'"
                                                                        @clearDatePicker="onDateFilterClearClick"
                                                                        @fromDateSelected="onFromDateCreatedSelect"
                                                                        @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
   </div>
</div>
